import './signInWithFacebook.scss';

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card } from 'components/base';
import Icon, { ICON_TYPE } from 'components/icon';
import classNames from 'classnames';
import useModalContext from 'components/context/modal';

const SignInWithFacebook = props => {
  const modalContext = useModalContext();

  useEffect(() => {
    //
    // TODO
    // This feature is still not supported.
    //
    if (props.fb) {
      props.fb.getLoginStatus(response => {
        if (response.status === 'connected') {
          // The user is logged in and has authenticated your
          // app, and response.authResponse supplies
          // the user's ID, a valid access token, a signed
          // request, and the time the access token
          // and signed request each expire.
          const uid = response.authResponse.userID;
          const accessToken = response.authResponse.accessToken;
        } else if (response.status === 'not_authorized') {
          // The user hasn't authorized your application.  They
          // must click the Login button, or you must call FB.login
          // in response to a user gesture, to launch a login dialog.
        } else {
          // The user isn't logged in to Facebook. You can launch a
          // login dialog with a user gesture, but the user may have
          // to log in to Facebook before authorizing your application.
        }
      });
    }
  }, [props.fb]);

  const handleOnFailed = error => {
    modalContext.hideSpinner();
    modalContext.toast(error, { type: 'warning' });
    props.onFailed(error);
  };

  const handleOnSignInClick = async e => {
    e.preventDefault();

    props.onLoading();
    modalContext.spinner(<>Getting your Facebook account...</>, {
      title: 'Login with Facebook',
    });

    await new Promise(resolve => {
      props.fb.login(
        loginResponse => {
          if (loginResponse.authResponse) {
            props.fb.api('/me?fields=id,name,email', async meResponse => {
              if (meResponse) {
                if (props.requiredEmail && !meResponse.email) {
                  handleOnFailed(
                    'We need your email address. Please allow us to get email address from your Facebook account. Otherwise we can not sign you in.',
                  );
                } else {
                  await props.onSuccess(meResponse);
                  modalContext.hideSpinner();
                }
              } else {
                handleOnFailed(
                  'Please allow us to get email address from your Facebook account. Otherwise we can not sign you in.',
                );
              }
            });
          } else {
            handleOnFailed('User cancelled login or did not fully authorized.');
          }
          resolve();
        },
        { scope: 'email' },
      );
    });
  };

  return (
    <>
      {props.fb && (
        <div className={props.className}>
          <Button type="facebook" onClick={handleOnSignInClick} className="facebook-button">
            <Icon type={ICON_TYPE.FACEBOOK} size={20} style={{ marginTop: -4, marginRight: 10 }} />
            Login with Facebook
          </Button>
        </div>
      )}
    </>
  );
};

SignInWithFacebook.propTypes = {
  fb: PropTypes.object,
  onLoading: PropTypes.func,
  onSuccess: PropTypes.func,
  onFailed: PropTypes.func,
  className: PropTypes.string,
  requiredEmail: PropTypes.bool,
  children: PropTypes.node,
};

SignInWithFacebook.defaultProps = {
  requiredEmail: false,
  onLoading: () => {},
  onFailed: console.error,
};

export const SignInWithFacebookToggler = ({ key = 'facebook', toggler, children, className }) => {
  const isOpen = toggler[0] === key;

  return (
    <Card className={classNames(isOpen ? 'border-black' : 'border-white', className)}>
      <Button
        type={isOpen ? 'default' : 'facebook'}
        className="w-100 transition-none"
        size="sm"
        onClick={() => {
          toggler[1](val => (val === key ? undefined : key));
        }}
      >
        <Icon
          type={ICON_TYPE.FACEBOOK}
          className="position-absolute"
          size={22}
          style={{ left: 15 }}
        />
        <span>Continue with Facebook</span>
      </Button>
      <Card.Body className={isOpen ? 'd-block' : 'd-none'}>{children}</Card.Body>
    </Card>
  );
};

export default SignInWithFacebook;
